import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-20">
      <div className="text-center max-w-lg">
        <span className="font-heading text-6xl md:text-8xl font-bold text-primary-500">404</span>
        <h1 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          这条线索走丢了
        </h1>
        <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
          你要找的页面不存在，或对应的爆料已被投稿人申请撤回。不妨回到首页，继续逛正在发酵的瓜料。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/square"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-700 text-sm font-medium whitespace-nowrap hover:bg-background-100 transition-colors"
          >
            <i className="ri-fire-line"></i>
            去爆料广场
          </Link>
        </div>
      </div>
    </div>
  );
}